import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { useMessageHidingMutation } from 'conversations-thread-data/message-hiding/hooks/useMessageHidingMutation';
import { jsx as _jsx } from "react/jsx-runtime";
export const useMessageHiding = () => {
  const [updateMessageHiding] = useMessageHidingMutation();
  const handleUnhideMessage = (messageId, userId) => {
    updateMessageHiding({
      variables: {
        isHidden: false,
        messageId,
        userId
      }
    }).then(() => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.unhideMessageAlert.alertSuccessTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.unhideMessageAlert.alertSuccessMessage"
        })
      });
    }).catch(error => {
      Raven.captureException(new Error(`Failed to unhide message ${messageId} for user ${userId}`), {
        extra: {
          errorMessage: error.message,
          messageId
        },
        tags: {
          isVisibleToUser: 'true'
        }
      });
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.unhideMessageAlert.alertFailureTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.unhideMessageAlert.alertFailureMessage"
        }),
        type: 'danger'
      });
    });
  };
  const handleHideMessage = (messageId, userId) => {
    updateMessageHiding({
      variables: {
        isHidden: true,
        messageId,
        userId
      }
    }).then(() => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.hideMessageAlert.alertSuccessTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.hideMessageAlert.alertSuccessMessage"
        })
      });
    }).catch(error => {
      Raven.captureException(new Error(`Failed to hide message ${messageId} for user ${userId}`), {
        extra: {
          errorMessage: error.message,
          messageId
        },
        tags: {
          isVisibleToUser: 'true'
        }
      });
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.hideMessageAlert.alertFailureTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.message-hiding.hideMessageAlert.alertFailureMessage"
        }),
        type: 'danger'
      });
    });
  };
  return {
    handleUnhideMessage,
    handleHideMessage
  };
};